import React from 'react'
import { useFetch } from '../../hooks/useFetch'
import { Container, Box, Grid, TextField, Typography, Button, Divider, Card, Paper, CardActions, CardContent } from '@mui/material/'
import { useState, useEffect } from 'react';
import SelectedStudent from '../SelectedStudent'
import ViewCarryOvers from './ViewCarryOvers'
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
    GridHeader,
    GridFooter,
    GridFooterContainer,
    GridFooterPlaceholder

} from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewCourseFeesForQuote from './ViewCourseFeesForQuote'
import ViewQuoteTotal from './ViewQuoteTotal'
import RemoveCouse from './RemoveCouse'
function ViewQuote({ studentId, quoteId, setViewQuote, setViewDelivery }) {



    const [tableData, setTableData] = useState([])
    const { getData, error, errorMessage, isPending, data } = useFetch(`https://dcregapi.bi-oss.co.za/quote/${quoteId}`, 'GET')


    const [remove, setRemove] = useState(0)
    const [removeId, setRemoveId] = useState('')
    const [addCourse, setAddCourse] = useState(0)
    const [addCarry, setAddCarry] = useState(0)
    const [catId, setCatId] = useState(2)

    const handleCompelte = (e) => {
        setRemoveId('')
        setRemove(0)
        setAddCourse(0)
        setAddCarry(0)
        getData()
    }

    useEffect((tableData) => {
        if (data) {
            setTableData(data)

        }


    }, [data])






    const columns = [

        { field: 'courseCode', headerName: 'Code:', width: 150 },
        { field: 'courseName', headerName: 'Course:', width: 300 },
        { field: 'courseFee', headerName: 'Fee::', width: 150, float: 'right' },

        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 120,
            renderCell: (params) => {
                const onClick1 = (e) => {
                    e.stopPropagation() // don't select this row after clicking
                    setRemoveId(params.row.id)
                    setRemove(1)

                }


                if (params.row.courseId !== 3) {

                    return <Button onClick={onClick1} variant="contained" color="error">Remove<DeleteIcon /></Button>;

                }

            }
        },




    ];

    const handleSubmit = (e) => {
        e.preventDefault()
        setViewQuote(0)
        setViewDelivery(1)
    }
    return (
        <>

            {!addCourse && !addCarry && !remove && (



                < Container maxWidth="md"  >
                    <form onSubmit={handleSubmit} autoComplete="off" >
                        <Box mb={5} />
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderColor: 'primary.main', borderRadius: 2 }}>
                            <>



                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Typography variant="h3" component="h3" color="primary.main" sx={{ textAlign: 'center' }}>
                                            Purchase BIDC Courses
                                        </Typography>



                                    </Box>


                                </Grid>


                                <Grid item xs={12}>

                                    {isPending && !error && (
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"

                                        >
                                            <Typography variant="h6" component="h3" color="primary">
                                                Fetching quote details ........
                                            </Typography>
                                        </Box>
                                    )}

                                    {error && !errorMessage && (
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"

                                        >
                                            <Typography variant="h6" component="h3" color="error">
                                                Unable to fetch quote details. You may be offline. Please try again.


                                            </Typography>
                                        </Box>
                                    )}
                                    {errorMessage && (
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"

                                        >
                                            <Typography variant="h6" component="h3" color="error">
                                                {errorMessage}


                                            </Typography>
                                        </Box>
                                    )}

                                </Grid>


                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >

                                        {new Date().getMonth() >= 8 && (
                                            <TextField

                                                id="Year"
                                                label="Academic Year"
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                value={new Date().getFullYear() + 1}
                                                fullWidth
                                                required
                                            />

                                        )}
                                        {new Date().getMonth() < 8 && (
                                            <TextField

                                                id="Year"
                                                label="Academic Year"
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                value={new Date().getFullYear()}
                                                fullWidth
                                                required
                                            />

                                        )}

                                    </Box>

                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >


                                        <SelectedStudent studentId={studentId} setStudentId={null} />

                                    </Box>

                                </Grid>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                            To add courses onto your cart, select add course, then select the course level and click add next to the desired course.
                                        </Typography>



                                    </Box>


                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >

                                        <Button fullWidth onClick={(e) => setAddCourse(1)} color="primary" variant="contained">Add Course</Button>


                                    </Box>

                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >

                                        <Button fullWidth onClick={(e) => setAddCarry(1)} color="primary" variant="contained">Add Carry Over</Button>


                                    </Box>

                                </Grid>

                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Typography variant="h6" component="h6" color="primary.main" sx={{ textAlign: 'center' }}>
                                            Your Cart
                                        </Typography>



                                    </Box>


                                </Grid>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                            <i>* Prices are subject to change</i>
                                        </Typography>



                                    </Box>


                                </Grid>
                                <Grid item xs={12} minWidth={0}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <DataGrid
                                            rows={tableData}
                                            columns={columns}



                                            sx={{ color: 'primary.main', borderColor: 'primary.main', borderWidth: 3, fontWeight: 'bold', m: 1, align: 'center', headerAlign: 'center', autoCapitalize: 'words' }}
                                            disableRowSelectionOnClick={true}
                                            disableColumnSelector={true}
                                            hideFooterRowCount
                                            hideFooterSelectedRowCount
                                            hideFooterPagination
                                            getRowId={(row) => row.id}
                                            autoHeight
                                            pageSize={(row) => row.length}
                                            components={{

                                                Footer: () => <ViewQuoteTotal quoteId={quoteId} />
                                            }}


                                        />
                                    </Box>


                                </Grid>


                            </>

                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                        Once you are ready to process your order payment online, click on Checkout. Please note, you will not be able to change your course selection during the checkout phase. Please ensure all required courses are in your cart before proceeding.
                                    </Typography>



                                </Box>


                            </Grid>

                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}

                                >

                                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}

                                        >

                                            <Button fullWidth type="submit" color="primary" variant="contained">Checkout</Button>


                                        </Box>

                                    </Grid>

                                </Box>

                            </Grid>

                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                        <b>Accepted Payment Methods:</b>
                                    </Typography>



                                </Box>


                            </Grid>
                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                        1: Online Secure EFT via our payment portal from any South African banking provider.
                                    </Typography>



                                </Box>


                            </Grid>
                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                        2: Debit or Credit card transactions from Visa or Mastercard holders.
                                    </Typography>



                                </Box>


                            </Grid>
                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                        Alternatively, should you wish to process a manual EFT or international transaction, please contact British International Distance College directly and request a manual registration form.
                                    </Typography>



                                </Box>


                            </Grid>

                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}

                                >

                                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}

                                        >

                                            <Button fullWidth onClick={(e) => setViewQuote(0)} color="primary" variant="contained">Cancel</Button>


                                        </Box>

                                    </Grid>

                                </Box>
                                <Box mb={5} />
                            </Grid>
                        </Grid>

                    </form>
                </Container>

            )}

            {addCourse === 1 && (

                <ViewCourseFeesForQuote handleCompelte={handleCompelte} quoteId={quoteId} catId={catId} setCatId={setCatId} setAddCourse={setAddCourse} />
            )}

            {remove === 1 && (
                <>
                    <RemoveCouse removeId={removeId} setRemove={setRemove} handleCompelte={handleCompelte} />
                </>
            )}
            {addCarry === 1 && (
                <>
                    <ViewCarryOvers studentId={studentId} handleCompelte={handleCompelte} quoteId={quoteId} setAddCarry={setAddCarry} />
                </>
            )}
        </>
    )
}

export default ViewQuote